import { MessageCircle } from "lucide-react";
import { Reveal, Eyebrow, WA_LINK } from "./shared";

export const ContactWhatsAppSection = () => (
  <section id="contatto" className="relative bg-black px-5 sm:px-10 lg:px-20 py-24 sm:py-36 grain">
    <div className="max-w-3xl mx-auto text-center">
      <Reveal>
        <Eyebrow className="mb-4">Il Tuo Prossimo Passo</Eyebrow>
        <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="application-title">
          Tra un anno vuoi essere ancora fermo <span className="gold-text">allo stesso punto?</span>
        </h2>
        <p className="text-[#b8b2a7] mt-6 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          «Non puoi cambiare tutto quello che ti è accaduto. Ma puoi iniziare ad assumerti la responsabilità di ciò che costruirai da oggi.»
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="font-display text-xl sm:text-2xl lg:text-3xl uppercase gold-text leading-snug mt-14" data-testid="contact-gold-phrase">
          La tua storia non deve finire dove sono iniziate le tue ferite.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="text-[#b8b2a7] text-base leading-relaxed max-w-2xl mx-auto mt-10">
          «Se senti che è arrivato il momento di lavorare sulla tua identità, sulla disciplina e sulla direzione della tua vita, scrivimi. Raccontami dove ti trovi oggi e cosa desideri cambiare. Ti spiegherò personalmente come funziona Uomo Biblico e valuteremo insieme se posso accompagnarti in questo percorso.»
        </p>
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-apply-cta"
          className="cta-gold rounded-full px-10 py-5 text-xs sm:text-sm uppercase inline-flex items-center gap-3 mt-10"
        >
          <MessageCircle size={16} /> Scrivimi in privato su WhatsApp
        </a>
        <p className="text-xs text-[#7a7367] mt-5">«Parlerai direttamente con Elio.»</p>
        <p className="font-display text-sm tracking-[0.3em] uppercase text-[#f3e5ab] mt-12">
          Cuore <span className="text-[#d4af37]">•</span> Voce <span className="text-[#d4af37]">•</span> Eredità
        </p>
      </Reveal>
    </div>
  </section>
);
